module.exports = __webpack_public_path__ + "img/pressure.67fa8a76.svg";